<template>    
    <div>
        <Monteria :municipio_id="id" v-if="id == 10" />
        <Cerete :municipio_id="id" v-if="id == 222" />
        <Covenas :municipio_id="id" v-if="id == 291" />
    </div>
</template>
<script>
    import axios from 'axios';
    import Covenas from '../Mapas/Covenas.vue';
    import Loading from '../Loader/Loading.vue';
    import Monteria from '../Mapas/Monteria.vue';
    import Cerete from '../Mapas/Cerete.vue';
    export default{
        components: {
            Monteria, Covenas, Loading, Cerete
        },
        data() {
            return {
                id: 0,
                loader: true,
                sedes: []
            }
        },
        mounted() {
            this.getSede()
        },
        methods: {
            async getSede(){
                this.id = this.$route.params.id;
                const res = await axios.get(`/api/sedes/${this.id}`, {
                    headers: {"Authorization": `Bearer ${this.$store.state.user.token}`}
                })
                this.sedes = res.data.sedes || null;
                this.loader = false
            }
        },
    }
</script>